import http from 'hub-http/clients/apiClient';
import chatflow from '../constants/chatflow.json';
import I18n from 'I18n';
/* @ts-expect-error bender url */
import defaultAvatar from 'bender-url!../../img/default-avatar.png';
import Raven from 'raven-js';
import { goToUrl } from './locationUtils';
import { getChatflowsUrl } from './urls';
import { IframeUtils } from 'feature-unboxing-common';
async function pollExistingInbox(retry = 0) {
  const res = await http.get('/messages/v2/inbox');
  if (res && res.inboxes.length > 0) {
    return res.inboxes[0];
  }
  if (retry < 5) {
    await new Promise(resolve => setTimeout(resolve, 5000));
    return pollExistingInbox(retry + 1);
  }
  throw new Error('No inbox found');
}
function updateInbox(inbox, changes) {
  inbox.availabilityStrategy = 'OFFICE_HOURS';
  inbox.accentColor = changes.color;
  inbox.autoCreated = false;
  return http.put(`/messages/v2/inbox/${inbox.id}`, {
    data: inbox
  });
}
function createChatflow(inbox, changes) {
  chatflow.welcomeMessage.chatHeadingConfig.companyLogoUrl = defaultAvatar;
  chatflow.welcomeMessage.chatHeadingConfig.customChatName = changes.customChatName;
  chatflow.welcomeMessage.createdAt = Date.now();
  chatflow.welcomeMessage.inboxId = inbox.id;
  chatflow.welcomeMessage.name = I18n.text('app.create.chatflowName');
  chatflow.welcomeMessage.askForEmailMessage = I18n.text('app.create.askForEmailMessage');
  chatflow.welcomeMessage.initialMessage = changes.welcomeMessage;
  return http.post(`chatflows/v1/chatflows/onboarding/for-welcome-message?locale=en-us`, {
    data: chatflow
  });
}
export default async function buildLiveChat(changes) {
  try {
    const inbox = await pollExistingInbox();
    if (inbox.autoCreated) {
      await updateInbox(inbox, changes);
      await createChatflow(inbox, changes);
    }

    // An inbox exists, but it's not auto-created. We don't want to change it
  } catch (e) {
    Raven.captureException(e);
  }
  if (!IframeUtils.isInIframe()) {
    goToUrl(getChatflowsUrl());
  }
}